import { useFeatureAccessInsights } from '../featureAccessInsights';

export const useIsMyInsightsEntryPointVisible = (): boolean => {
  const featureAccessInsights = useFeatureAccessInsights();

  return featureAccessInsights?.canViewActivity === true;
};
